import { Link } from 'react-router-dom';

const LINKS = [
  { label: 'Session', to: '/session/1' },
  { label: 'Exchange', to: '/exchange' },
  { label: 'Mentors', to: '/mentors' },
  { label: 'Stack', to: '/stack' },
  { label: 'Interest', to: '/interest' },
];

const Footer = () => (
  <footer
    data-testid="global-footer"
    className="border-t border-black/[0.06] py-8 mt-16"
  >
    <div className="max-w-6xl mx-auto px-6 text-center">
      <nav className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 mb-4" data-testid="footer-nav">
        {LINKS.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            data-testid={`footer-nav-${link.label.toLowerCase()}`}
            className="text-sm font-medium text-ink-secondary hover:text-ink transition-colors"
          >
            {link.label}
          </Link>
        ))}
      </nav>
      <p className="text-xs text-ink-muted">
        AI Lab &nbsp;·&nbsp; A Goodera × Basecamp session &nbsp;·&nbsp; Bengaluru, 12 Aug 2026
      </p>
    </div>
  </footer>
);

export default Footer;
